import { Component, input, output, model } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../../ui/icon/icon.component';
import { transitionAnimation } from '../../../scss/themes/animation';
import { NgOptimizedImage } from '@angular/common';


@Component({
  selector: 'app-industries-menu',
  templateUrl: './industries-menu.component.html',
  styleUrls: ['./industries-menu.component.scss'],
  imports: [
    IconComponent,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    NgOptimizedImage
  ],
  animations: [transitionAnimation]
})
export class IndustriesMenuComponent {
  view = input<'desktop' | 'mobile'>('desktop');

  onSelect = output<void>();

  isOpen = model(false);

  readonly industries: any[] = [
    {
      title: 'SOLUTIONS.OFFSHORE',
      route: '/bransje/offshore',
      logos: [
        {
          src: '/assets/img/website/offshore/logo/torvald.png',
          width: 73,
          height: 24,
          alt: 'Torvald Klaveness logo'
        },
        {
          src: '/assets/images/logos/solstad_offshore.png',
          width: 84,
          height: 26,
          alt: 'Solstad Offshore'
        },
        {
          src: '/assets/img/website/offshore/logo/sea1.png',
          width: 52,
          height: 13,
          alt: 'Sea1 logo'
        },
        {
          src: '/assets/img/website/offshore/logo/westcon.png',
          width: 88,
          height: 13,
          alt: 'Westcon logo'
        }
      ]
    },
    {
      title: 'SOLUTIONS.RETAIL',
      route: '/bransje/retail',
      logos: [
        {
          src: '/assets/images/logos/kaffebrenneriet.png',
          width: 109,
          height: 20,
          alt: 'Kaffebrenneriet logo'
        },
        {
          src: '/assets/img/website/retail/devold.png',
          width: 72,
          height: 17,
          alt: 'Devold logo'
        },
        {
          src: '/assets/img/website/retail/eplehuset.png',
          width: 43,
          height: 30,
          alt: 'Eplehuset logo'
        },
        {
          src: '/assets/img/website/retail/jernia.png',
          width: 73,
          height: 17,
          alt: 'Jernia logo'
        }
      ]
    },
    {
      title: 'SOLUTIONS.LAW',
      route: '/bransje/advokathus',
      logos: [
        {
          src: '/assets/img/lawyer/haavind.png',
          width: 85,
          height: 20,
          alt: 'Haavind logo'
        },
        {
          src: '/assets/img/lawyer/elden.png',
          width: 73,
          height: 24,
          alt: 'Elden logo'
        },
        {
          src: '/assets/images/logos/arntzen_grette.png',
          width: 155,
          height: 10,
          alt: 'Arntzen Grette logo'
        }
      ]
    },
    {
      title: 'SOLUTIONS.GROUP_STRUCTURE',
      route: '/bransje/konsern',
      logos: [
        {
          src: '/assets/img/website/group-structure/fred_plsen.png',
          width: 130,
          height: 13,
          alt: 'Fred Olsen logo'
        },
        {
          src: '/assets/img/website/group-structure/ikm_logo.png',
          width: 44,
          height: 40,
          alt: 'IKM logo'
        },
        {
          src: '/assets/img/website/group-structure/bransdal.png',
          width: 141,
          height: 20,
          alt: 'Brandsdal logo'
        }
      ]
    },
    {
      title: 'SOLUTIONS.CONSTRUCTION',
      route: '/bransje/bygg-anlegg',
      logos: [
        {
          src: '/assets/images/logos/lett_tak.png',
          width: 79,
          height: 20,
          alt: 'Lett Tak logo'
        },
        {
          src: '/assets/images/logos/maskin.png',
          width: 94,
          height: 22,
          alt: 'Maskin logo'
        },
        {
          src: '/assets/images/logos/aase.png',
          width: 48,
          height: 26,
          alt: 'Aase logo'
        },
        {
          src: '/assets/images/logos/helgevold.png',
          width: 109,
          height: 10,
          alt: 'Helgevold logo'
        }
      ]
    }
  ];

  toggleIsOpen(): void {
    this.isOpen.set(!this.isOpen());
  }

  selectOption(): void {
    this.onSelect.emit();
  }
}
